import { z } from "zod";
import { passwordSchema } from "./passwordValidator";

export const createClienteFinalWithUserSchema = z.object({
  usuario: z.object({
    nombreUsuario: z.string().min(2),
    correo: z.string().email(),
    contrasena: passwordSchema,
    nombre: z.string().min(2),
    apellidoPaterno: z.string().min(2),
    apellidoMaterno: z.string().optional(),
    idRol: z.literal(3),
  }),
  cliente: z.object({
    nombreEmpresa: z.string().min(1, "Nombre de la empresa requerido"),
    idUsuarioAlta: z.string(),
    logoMarca: z
      .union([
        z.object({
          llave: z.string(),
          nombre: z.string(),
          url: z.string().url().optional(),
        }),
        z.null(),
        z.undefined(),
      ])
      .optional(),
    logoMarcaInverso: z
      .union([
        z.object({
          llave: z.string(),
          nombre: z.string(),
          url: z.string().url().optional(),
        }),
        z.null(),
        z.undefined(),
      ])
      .optional(),
    colorPrimario: z.string().nullable().optional(),
    colorSecundario: z.string().nullable().optional(),
    colorTextoPrimario: z.string().nullable().optional(),
    colorTerciario1: z.string().nullable().optional(),
    colorTerciario2: z.string().nullable().optional(),
    tipografiaMarca: z.string().nullable().optional(),
  }),
});

export type CreateClienteFinalWithUserInput = z.infer<
  typeof createClienteFinalWithUserSchema
>;
